"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _AppException2 = _interopRequireDefault(require("./AppException"));
/**
 * Never use this to handle user input
 *
 * This exception is to terminate bugs. I.e. throw it in situations, that should never happen
 * according to the correct implementation
 */

var UnexpectedCaseException = /*#__PURE__*/
function (_AppException) {
  (0, _inherits2.default)(UnexpectedCaseException, _AppException);
  function UnexpectedCaseException(message) {
    (0, _classCallCheck2.default)(this, UnexpectedCaseException);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnexpectedCaseException).call(this, message || 'Unexpected case'));
  }
  return UnexpectedCaseException;
}(_AppException2.default);
exports.default = UnexpectedCaseException;